import React from "react";
import PropTypes from "prop-types";

import { AdminLayoutAnonymous } from "@rdcs/dap-front-library";

const ErrorScreen = ({ title, content }) => (
    <AdminLayoutAnonymous>
        <div className="appLoading">
            <div className="appLoading__container">
                <h1 className="title-1">{title}</h1>
                <p className="text-3">{content}</p>
            </div>
        </div>
    </AdminLayoutAnonymous>
);

ErrorScreen.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
};

export default ErrorScreen;
